RivalIQ.apps.Dashboard.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    function getSummaryTitles(view, model) {
        const titleFormatter = model.get('titleFormatter') || RivalIQ.formatter.urlShort;
        return {
            titleUnabridged: model.get('titleUnabridged') || model.getName({
                abbreviate: true
            }),
            title: model.getName({
                abbreviate: true,
                formatter: titleFormatter
            }),
            className: model.getClassName(),
            unabbreviatedValue: model.format(model.getValue({
                format: false
            }), {
                expand: true
            })
        };
    }

    utils.getSummaryTemplateHelpers = function (view, model) {
        if (model) {
            return _.extend({
                value: model.getValue()
            }, getSummaryTitles(view, model));
        } else {
            return {};
        }
    };

    utils.execWithBuffering = function (fcn) {
        let startedBuffering = false;
        if (!RivalIQ.data.CacheLayer.isBuffering()) {
            startedBuffering = true;
            RivalIQ.data.CacheLayer.startBuffering();
        }

        const result = fcn();

        if (startedBuffering) {
            RivalIQ.data.CacheLayer.stopBuffering();
            RivalIQ.data.CacheLayer.flush();
        }

        return result;
    };
});
